import type { StyleWithVars } from './types.js';
import type { ReactElement } from 'react';

type ArtTileProps = {
  readonly album: string;
  readonly artUrl?: string | null;
  readonly label?: string;
  readonly className?: string;
};

const HUE_SEED = 7;
const HUE_STEP = 31;
const HUES = 360;

/** Same album, same colours, on every device and every replay — the art is derived, not stored. */
const hueOf = (text: string): number =>
  Array.from({ length: text.length }, (_unused, index) => text.codePointAt(index) ?? 0).reduce(
    (hue, code) => (hue * HUE_STEP + code) % HUES,
    HUE_SEED,
  );

export const ArtTile = ({ album, artUrl, label, className }: ArtTileProps): ReactElement => {
  const classes = className === undefined ? 'art' : `art ${className}`;
  const name = label === undefined || label === '' ? album : label;

  if (artUrl !== undefined && artUrl !== null && artUrl !== '') {
    return (
      <div className={classes}>
        <img src={artUrl} alt={name} />
      </div>
    );
  }

  const firstCodePoint = name.trim().codePointAt(0);
  const initial = firstCodePoint === undefined ? '' : String.fromCodePoint(firstCodePoint);
  const style: StyleWithVars = { '--h': String(hueOf(album)) };

  return (
    <div className={classes}>
      <span className="art-fallback" style={style} aria-hidden="true">
        {initial}
      </span>
      <span className="vh">{name}</span>
    </div>
  );
};
